import styles from './CreateSIZRightPanel.module.css';
import AddMaterialItem from '../../../AddMaterialItem/AddMaterialItem';
import InputForm from '../../../InputForm/InputForm';
import Button from '../../../Button/Button';

export default function CreateSIZRightPanel({
	items,
	typesDict,
	onItemChange,
	onItemRemove,
	startDate,
	onStartDateChange,
	onStartDateBlur,
	numberOfDocument,
	onNumberOfDocumentChange,
	onSubmit,
	submitDisabled
}) {
	const today = new Date().toISOString().slice(0, 10);

	return (
		<div className={styles.panel}>
			{items.length > 0 && (
				<div className={styles.commonFields}>
					<label className={styles.label}>
						Дата выдачи*:
						<InputForm
							value={startDate || today}
							type="date"
							name="start_date"
							onChange={onStartDateChange}
							onBlur={onStartDateBlur}
						/>
					</label>
					<label className={styles.label}>
						Номер документа:
						<InputForm
							value={numberOfDocument || ''}
							type="text"
							name="number_of_document"
							placeholder="Номер документа"
							onChange={onNumberOfDocumentChange}
						/>
					</label>
				</div>
			)}
			<div className={styles.list}>
				{items.length === 0 && (
					<p className={styles.empty}>Добавьте материалы к выдаче</p>
				)}
				{items.map((item, idx) => (
					<AddMaterialItem
						key={item.id}
						item={item}
						typesDict={typesDict}
						onChange={(updated) => onItemChange(idx, updated)}
						onRemove={() => onItemRemove(idx)}
					/>
				))}
			</div>
			{items.length > 0 && (
				<div className={styles.submit}>
					<Button onClick={onSubmit} disabled={submitDisabled} type="button">
						Выдать и распечатать
					</Button>
				</div>
			)}
		</div>
	);
}